export function isLikelyPhone() {
  if (typeof window === "undefined") return false;
  const uaMobile = navigator.userAgentData?.mobile ?? /Android|iPhone|iPod|Mobile/i.test(navigator.userAgent);
  const coarse = window.matchMedia?.("(pointer: coarse)").matches;
  return Boolean(uaMobile || (coarse && window.innerWidth < 900));
}
